<template>
	<div>
		<div class="m-d-8"
		     v-for="(layanan, i) in transaksi.rincian_layanan" :key="i"
		>
			<div class="d-inline" style="max-width: 70%">
				<div class="d-flex-between-center align-items-start ">
					<div>
						<span class="f-regular f-14 f-c-black">
							{{ layanan.nama_layanan }}
						</span>
						<span class="f-regular f-14 f-c-midgrey">  •  {{ layanan.jumlah_beli }} {{ layanan.satuan }}</span>
					</div>
					<div class="f-regular f-14 f-c-black">
						{{ formatRupiah(layanan.harga_total.toString()) }}
					</div>
				</div>
				<div v-if="isHavePromo(layanan.iddetlayanan)" class="d-flex-between-center f-12 f-c-midgrey">
					<span>
						Diskon {{ transaksi.promo.meta.name }}
					</span>
					<span>
						(-) {{ serviceDiscount(layanan.iddetlayanan) }}
					</span>
				</div>
				<div class="f-regular f-12 f-c-midgrey" v-if="layanan.total_load > 0">
					{{ layanan.total_load }}x siklus mesin
				</div>
				<div class="f-semi f-12 f-c-blue" @click="detailLayanan(transaksi.detail_transaksi.idtransaksi, layanan.iddetlayanan)">
					Lihat detail
					<img height="12px" src="@/assets/icons/chevron-rotate-down.svg" alt="">
				</div>
			</div>
		</div>

		<div v-if="produk.length > 0" class="">
			<div
				v-for="(item, index) in produk" :key="index"
				:class="`d-flex-between-center ${index == 0 ? '' : 'p-t-8'} f-14`"
			>
				<div class="d-flex" style="gap: 8px">
					<div class="f-14 f-c-black f-regular">
						{{item.inventori_produk.nama}}
					</div>
					<div class="f-c-midgrey">
						• {{item.qty}} {{item.inventori_item.satuan.nama}}
					</div>
				</div>
				<div>
					{{formatRupiah(item.harga * item.qty)}}
				</div>
			</div>
		</div>

		<div class="tarif-express m-d-12" v-if="transaksi.detail_transaksi.tarif_tambahan > 0">
			<div class="f-regular f-14 f-c-black">
				Tarif Express
			</div>
			<div class="f-regular f-14 f-c-midgrey">
				Total layanan ({{ formatRupiah(transaksi.detail_transaksi.total.toString()) }}) x
				{{ parseFloat(transaksi.detail_transaksi.tarif_kali) }}
			</div>
		</div>

		<div class="separator-line-dot m-t-4 m-d-12"></div>

		<TransaksiModalDetailLayanan
			v-if="pageSetting.modal.show"
			:idtransaksi="idtranksaksi"
			:iddetlayanan="iddetlayanan"
			@close="() => { pageSetting.modal.show = false }"
		/>
	</div>
</template>

<script>
import TransaksiModalDetailLayanan
	from "@/modules/transaksi-global/transaksi-reguler/views/modal/TransaksiModalDetailLayanan";

export default {
	name: "SOTagihanLayanan",
	props: {
		transaksi: Object,
	},
	components: {
		TransaksiModalDetailLayanan,
	},
	data() {
		return {
			pageSetting: {
				modal: {
					show: false,
				}
			},
			idtranksaksi: "",
			iddetlayanan: "",
		}
	},
	methods: {
		detailLayanan(idtransaksi, iddetlayanan) {
			this.idtranksaksi = idtransaksi
			this.iddetlayanan = iddetlayanan
			this.pageSetting.modal.show = true
		},
		isHavePromo(serviceId) {
			if ((this.transaksi.promo?.discount?.service?.length ?? 0) == 0) return false
			return this.transaksi.promo?.discount?.service.find(el => { return el.iddetlayanan == serviceId}) != undefined
		},
		serviceDiscount(serviceId) {
			const discount = this.transaksi.promo?.discount?.service.find(el => { return el.iddetlayanan == serviceId})
			return this.formatRupiah(discount.discount.toString());
		}
	},
	computed: {
		produk() {
			return this.transaksi.produk;
		},
	}
}
</script>

<style>
.tarif-express {
	background: linear-gradient(90deg, #EDEDED 0%, rgba(237, 237, 237, 0) 100%);
	border-radius: 5px;
	padding: 6px 12px;
}
</style>